import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Loader2 } from "lucide-react";

export default function Register() {
  const { register, error } = useAuth();
  const [form, setForm] = useState({ name: "", pharmacy_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const ok = await register(form);
    setLoading(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="register-page">
      <div className="w-full max-w-md card p-8 fade-in">
        <div className="flex items-center gap-2 mb-8">
                    <div className="font-display font-extrabold text-xl tracking-tight">
            <img src="/img/farmanaliza-logo.png?v=3" alt="Farmanaliza" className="h-12 w-auto inline-block" data-testid="register-logo" />
          </div>
        </div>
        <h1 className="font-display text-2xl font-extrabold mb-1">Crear cuenta</h1>
        <p className="text-sm text-slate-600 mb-6">Empieza a analizar tu estudio en minutos.</p>

        <form onSubmit={onSubmit} className="space-y-3">
          <input data-testid="register-name-input" required placeholder="Tu nombre"
                 value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                 className="input" />
          <input data-testid="register-pharmacy-input" placeholder="Nombre de la farmacia"
                 value={form.pharmacy_name} onChange={(e) => setForm({ ...form, pharmacy_name: e.target.value })}
                 className="input" />
          <input data-testid="register-email-input" type="email" required placeholder="email@farmacia.com"
                 value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                 className="input" />
          <input data-testid="register-password-input" type="password" required minLength={6} placeholder="Contraseña (mín 6)"
                 value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                 className="input" />
          {error && (
            <div data-testid="register-error" className="text-sm text-red-700 bg-red-50 px-3 py-2 rounded border border-red-200">
              {error}
            </div>
          )}
          <button data-testid="register-submit-button" disabled={loading} type="submit" className="btn btn-primary w-full justify-center">
            {loading ? <><Loader2 size={16} className="animate-spin" /> Creando…</> : "Crear cuenta"}
          </button>
        </form>
        <div className="mt-4 text-sm text-slate-600 text-center">
          ¿Ya tienes cuenta?{" "}
          <Link data-testid="goto-login-link" to="/login" className="font-semibold text-slate-900 hover:underline">Inicia sesión</Link>
        </div>
      </div>
    </div>
  );
}
